import { render, staticRenderFns } from "./SecurityNotifications.vue?vue&type=template&id=5b7a1268&scoped=true&"
import script from "./SecurityNotifications.vue?vue&type=script&lang=js&"
export * from "./SecurityNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SecurityNotifications.vue?vue&type=style&index=0&id=5b7a1268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a1268",
  null
  
)

export default component.exports